import { createClient } from '@supabase/supabase-js';
import { supabaseAuthStorage } from '../utils/supabaseAuthStorage';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const hasSupabaseConfig = Boolean(supabaseUrl && supabaseAnonKey);
export const supabaseConfigError = hasSupabaseConfig
  ? null
  : 'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Add both variables in Netlify Site settings > Environment variables and redeploy.';

if (!hasSupabaseConfig) {
  console.error(supabaseConfigError);
}

const supabase = hasSupabaseConfig
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        storage: supabaseAuthStorage,
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: 'pkce',
      },
    })
  : null;

// Isolated client for admin user creation — signUp must not touch the main session.
const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

export const createEphemeralSupabaseClient = () => {
  if (!hasSupabaseConfig) return null;
  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      storage: noopStorage,
      storageKey: 'sb-ephemeral-signup',
    },
  });
};

export default supabase;
